<div class="w-full">
  <div
    *ngIf="storageUpgradeOptions"
    class="relative w-full inline-block text-left"
    (clickOutside)="storageUpgradeDropdownCollapsed = true"
  >
    <div class="w-full">
      <button
        type="button"
        class="select-dark"
        id="menu-button"
        aria-expanded="true"
        aria-haspopup="true"
        (click)="
          storageUpgradeDropdownCollapsed = !storageUpgradeDropdownCollapsed
        "
      >
        <span class="flex-1 text-left">{{ storageUpgrade.label }} </span>
        <span class="text-left text-gray-400"
          >+
          {{
            storageUpgrade.price
              | currency: storageUpgrade.currencyCode : "symbol" : "1.2-2"
          }}{{ storageUpgrade.periodLabel }}
        </span>
        <!-- Heroicon name: solid/chevron-down -->
        <svg
          class="-mr-1 ml-2 h-5 w-5"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fill-rule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
    </div>

    <div
      *ngIf="!storageUpgradeDropdownCollapsed"
      class="origin-top-left absolute z-40 rounded-lg left-0 mt-2 p-2 w-full text-gray-200 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-gray-200 dark:focus:ring-white dark:focus:border-white dark:shadow-sm-light text-sm"
      role="menu"
      aria-orientation="vertical"
      aria-labelledby="menu-button"
      tabindex="-1"
    >
      <div class="py-1" role="none">
        <div
          *ngFor="let option of storageUpgradeOptions"
          class="flex block px-4 py-2 hover:bg-gray-600 hover:text-gray-200 rounded-lg hover:font-semibold cursor-pointer"
          role="menuitem"
          tabindex="-1"
          (click)="selectStorageUpgrade(option)"
        >
          <span
            class="flex-1 text-left"
            [class]="{ 'opacity-50': option.soldOut }"
            >{{ option.label }}{{ option.soldOut ? " (Sold out)" : "" }}
          </span>
          <span
            class="text-left text-gray-400"
            [class]="{ 'opacity-50': option.soldOut }"
            >+
            {{
              option.price | currency: option.currencyCode : "symbol" : "1.2-2"
            }}{{ option.periodLabel }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
